"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdRecaptchaClass = void 0;
const rxjs_1 = require("rxjs");
/**
 * CLASSE INTERNA
 * da non esportare fuori da commons
 */
class TpdRecaptchaClass {
    constructor(size, hidden, siteKey) {
        this.size = size;
        this.subject = new rxjs_1.Subject();
        this.recaptcha = null;
        this.hidden = hidden;
        this.siteKey = siteKey;
    }
}
exports.TpdRecaptchaClass = TpdRecaptchaClass;
